// Function to get the color of the star based on the rating value
// 1. 0 = no rating
// 2. 1-2 = red
// 3. 2-3 = yellow
// 4. 4-5 = green
const getStarColor = (
  value: number
): "inherit" | "error.main" | "warning.main" | "success.main" => {
  if (value === 0) {
    return "inherit";
  } else if (value < 2) {
    return "error.main";
  } else if (value < 4) {
    return "warning.main";
  } else {
    return "success.main";
  }
};

export default getStarColor;
